import React from 'react';
import styled from 'styled-components';
import { LoadingIcon } from '@prosolve/common-components-ui'
import FolderTile from './FolderTile';
import FileTile from './FileTile';
import { assetTheme as t } from './assetTheme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

const SectionLabel = styled.div`
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: ${t.faint};
`

const FolderRow = styled.div`
  display: grid;
  grid-template-columns: ${({ $isMobileView }) => $isMobileView ? '1fr' : 'repeat(auto-fill, minmax(220px, 1fr))'};
  gap: 12px;
`

const FileGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $isMobileView }) => $isMobileView ? '1fr 1fr' : 'repeat(auto-fill, minmax(210px, 1fr))'};
  gap: 16px;
`

const EmptyNote = styled.div`
  padding: 40px 0px;
  width: 100%;
  text-align: center;
  color: ${t.faint};
  font-style: italic;
`

export default ({
  isLoading,
  folders = [],
  files = [],
  isMobileView,
  isSelectMode,
  selectedFile,
  onSelectFile,
  onOpenFolder,
  onRenameFolder,
  onDeleteFolder,
  onDropFile,
  onPreviewFile,
  onRenameFile,
  onDeleteFile
}) => {
  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
        <LoadingIcon />
      </div>
    )
  }

  if (folders.length === 0 && files.length === 0) {
    return <EmptyNote>{'This folder is empty. Upload files or create a folder to get started.'}</EmptyNote>
  }

  return (
    <Wrapper>
      {
        folders.length > 0 &&
        <>
          <SectionLabel>{'Folders'}</SectionLabel>
          <FolderRow $isMobileView={isMobileView}>
            {folders.map((folder) => (
              <FolderTile
                key={folder.path}
                folder={folder}
                onOpen={onOpenFolder}
                onRename={onRenameFolder}
                onDelete={onDeleteFolder}
                onDropFile={onDropFile}
              />
            ))}
          </FolderRow>
        </>
      }
      {
        files.length > 0 &&
        <>
          <SectionLabel>{'Files'}</SectionLabel>
          <FileGrid $isMobileView={isMobileView}>
            {files.map((file) => (
              <FileTile
                key={file.key}
                file={file}
                isSelectMode={isSelectMode}
                isSelected={!!selectedFile && selectedFile.key === file.key}
                onSelect={onSelectFile}
                onPreview={onPreviewFile}
                onRename={onRenameFile}
                onDelete={onDeleteFile}
              />
            ))}
          </FileGrid>
        </>
      }
    </Wrapper>
  )
}
